/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { FormattedMessage } from 'react-intl';

import moment from 'utils/moment';
import Status from './Status';

import styles from '../../../../styles/general.module.scss';

const Table = ({ info, schema }) => (
  <table className={styles.table}>
    <thead>
      <tr>
        <th>
          <FormattedMessage id="workorder.detail.request.requested_by" defaultMessage="Requested by" />
        </th>
        <th>
          <FormattedMessage
            id={schema?.schema?.default_fields?.default_reported_date?.title || 'workorders.list.table.reported'}
            defaultMessage={schema?.schema?.default_fields?.default_reported_date?.title || 'Reported'}
          />
        </th>
        <th>
          <FormattedMessage
            id={schema?.schema?.default_fields?.default_category?.title || 'workorders.list.table.category'}
            defaultMessage={schema?.schema?.default_fields?.default_category?.title || 'Category'}
          />
        </th>
        <th>
          <FormattedMessage id="workorders.list.table.status" defaultMessage="Status" />
        </th>
        <th />
      </tr>
    </thead>
    <tbody>
      {!info.length > 0 ? (
        <tr>
          <td className="noTableData" colSpan={7}>
            <FormattedMessage id="WorkOrders.list.table.no_results" defaultMessage="There are no workorders on the selected range" />
          </td>
        </tr>
      )
        : (
          info.map(e => (
            <tr key={e.id}>
              <td>
                {e?.logged_by ? (e?.logged_by?.fullname) : (
                  (e?.public_info && e?.public_info?.name && e?.public_info?.last_name && `${e?.public_info?.name} ${e?.public_info?.last_name}`)
                    || (e?.public_info?.name)
                    || (e?.public_info?.last_name)
                    || ('Public'))}
              </td>
              <td className={styles.date}>{(moment(e.report_date)).format('MM/DD/YYYY hh:mm A')}</td>
              <td>{e.category}</td>
              <td><Status item={e.status=== 12 ? e : e.status} /></td>
              <td>
                <Link to={`/maintenance/${e.order_number}/detail`}>
                  <FormattedMessage id="workorders.list.table.action" defaultMessage="View" />
                </Link>
              </td>
            </tr>
          ))
        )
        }
    </tbody>
  </table>
);

Table.propTypes = {
  info: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default Table;
